import styled, { theme } from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'
import PropTypes from 'prop-types'
import React from 'react'

import { margins } from '../../styles/margins'
import { Icon } from '../icons'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${rem(5)};
  ${(p) => p.theme.media.min.lg`
    padding: ${rem(15)} ${rem(margins.m)};
    margin: 0;
  `}
`

const Label = styled.span`
  padding-top: ${rem(4)};
  font-weight: ${theme('navigation.item.fontWeight')};
  font-size: ${(p) => rem(p.theme.navigation.item.fontSize)};

  ${(p) => p.theme.media.min.lg`
    font-size: ${rem(p.theme.navigation.item.lg.fontSize)};
  `}
`

const IconWrapper = styled.span`
  height: ${rem(21)};
  position: relative;

  :after {
    display: ${(p) => (p.notification ? 'block' : 'none')};
    content: '';
    position: absolute;
    width: ${rem(10)};
    height: ${rem(10)};
    top: -${rem(5)};
    right: -${rem(5)};
    border: ${rem(1)} solid #fff;
    border-radius: 50%;
    background-color: #cf2222;
  }
`

const NavigationItem = ({ label, icon, notification }) => (
  <Wrapper>
    <IconWrapper notification={notification}>
      <Icon name={icon} height="100%" />
    </IconWrapper>
    <Label>{label}</Label>
  </Wrapper>
)

NavigationItem.defaultProps = {
  notification: false,
}

NavigationItem.propTypes = {
  notification: PropTypes.bool,
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
}

export default NavigationItem
